var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": ("carousel-item-" + _vm.order),
      "enter-to-class": ("carousel-item-" + _vm.direction),
      "leave-to-class": ("active carousel-item-" + _vm.direction)
    },
    on: {
      "after-enter": function($event) {
        _vm.clz = ['active']
      },
      "after-leave": function($event) {
        _vm.clz = ['']
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "carousel-item",
    class: _vm.clz
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  }, [_vm._t("caption")], 2)], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f913aea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/CarouselItem.vue
// module id = 142
// module chunks = 19